import logger from '@eb/logger-bugsnag';

import DividerModule from './Divider';
import CallToActionModule from './CallToAction';
import CallToActionHeroModule from './CallToActionHero';
import EmptyModule from '../sharedComponents/EmptyModule';
import FAQModule from './Faq';
import FeatureModule from './Feature';
import ImageResourceCardsModule from './ImageResourceCards';
import PricingModule from './Pricing';
import PayoutModule from './Payout';
import ProductHighlightModule from './ProductHighlight';
import RawHTMLModule from './RawHtml';
import ResourceCardsModule from './ResourceCards';
import RichTextModule from './RichText';
import TestimonialsModule from './Testimonial';
import VideoModule from './Video';
import { functionalSafeComponent } from '../../SafeComponentWrapper';
import PricingCalculatorModule from './PricingCalculator';

interface ModuleDictionary {
    faq_content: any;
    image_resource_cards_content: any;
    raw_html_content: any;
    payout_content: any;
    product_highlight_content: any;
    testimonials_content: any;
    resource_cards_content: any;
    feature_content: any;
    divider_content: any;
    call_to_action_content: any;
    video_content: any;
    call_to_action_hero_content: any;
    rich_text_content: any;
    pricing_content: any;
    pricing_calculator_content: any;
}

const MODULE_TYPE_TO_COMPONENT: ModuleDictionary = {
    call_to_action_content: CallToActionModule,
    divider_content: DividerModule,
    faq_content: FAQModule,
    feature_content: FeatureModule,
    image_resource_cards_content: ImageResourceCardsModule,
    pricing_content: PricingModule,
    raw_html_content: RawHTMLModule,
    payout_content: PayoutModule,
    product_highlight_content: ProductHighlightModule,
    resource_cards_content: ResourceCardsModule,
    testimonials_content: TestimonialsModule,
    video_content: VideoModule,
    call_to_action_hero_content: CallToActionHeroModule,
    rich_text_content: RichTextModule,
    pricing_calculator_content: PricingCalculatorModule,
};

export const getModuleComponent = (type: string) => {
    if (!MODULE_TYPE_TO_COMPONENT.hasOwnProperty(type)) {
        logger.warn('Unknown Wagtail module type.', { type });
        return EmptyModule;
    }

    return functionalSafeComponent(
        MODULE_TYPE_TO_COMPONENT[type as keyof ModuleDictionary],
    );
};
